import React from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CButton } from '@/components/CButton';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  return (
    <div className="h-full flex items-center justify-center">
      <Result
        status="403"
        title="403"
        subTitle={t('common:common.unauthorized_access')}
        extra={
          <CButton variant="primary" onClick={() => navigate('/dashboard-panel')}>
            {t('common:common.go_to_dashboard')}
          </CButton>
        }
      />
    </div>
  );
};

export default Unauthorized;
